import { requestGet } from '@/common/request';

export interface floorListParams {
  towerId: string;
  pageId: string;
  platform: number;
}

export interface floorListRes {
  ret: string;
  msg: string;
  data: {
    list?:
      | Array<{
          floorName: string;
          templateName: string;
          materialType: number;
          materialGroups?:
            | Array<{
                materialGroupId: string;
                materialGroupType: number;
                materialGroupSource: string;
                createErp: string;
              }>
            | [];
        }>
      | [];
  };
}

//日常活动 - 通天塔楼层信息
export async function floorList(params: floorListParams): Promise<floorListRes> {
  return await requestGet('/room/floorList', params);
}
